import Link from 'next/link'

import { useCurrentPath } from '../../hooks/use-current-path'

import { HistoryIcon } from './assets/history-icon'

import cl from './style.module.scss'

export interface SearchCatsProps {
	items: string[]
	linkSalt?: string
}

export const SearchHistory = (props: SearchCatsProps) => {
	const { items } = props
	const { withSalt } = useCurrentPath()

	return (
		<div className={cl.cats}>
			<h4 className={cl.title}>История</h4>
			{items?.map(item => (
				<Link prefetch={false} href={`/catalog/products/${item}?${withSalt}`} key={item} className={cl.item}>
					<HistoryIcon />
					<p className={cl.label}>{item}</p>
				</Link>
			))}
		</div>
	)
}
